import React, { useEffect, useRef, useState } from "react";
import image from "../../asset/about rda.jpeg";
import { NavLink } from "react-router-dom";

const AboutRDA = () => {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
  }, []);
  return (
    <div className="flex md:flex-row flex-col-reverse justify-center items-center xl:gap-4 md:gap-3 gap-5 xl:px-[5%] lg:px-[3%] md:px-[2.5%] px-[4%] xl:py-16 lg:py-12 py-8">
      <div className="lg:flex-1 md:w-[40%] w-full flex justify-center ">
        <img
          ref={ref}
          src={image}
          className={`xl:w-[80%] lg:w-[85%] md:w-[85%] w-full rounded-xl ${
            isVisible ? "animate-slideRight" : "opacity-0"
          } `}
          alt=""
        />
      </div>
      <div
        ref={ref}
        className={` flex-1 flex flex-col items-start justify-center lg:gap-2 md:gap-1 gap-2 ${
          isVisible ? "animate-slideLeft" : "opacity-0"
        } `}
      >
        <span className="xl:text-[1.2rem] lg:text-[1rem] md:text-[.9rem] text-[1rem] uppercase text-[#00643B] font-semibold">
          About
        </span>
        <span className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] font-bold">
          Rawalpindi Development Authority
        </span>
        <span className="xl:text-[1.2rem] lg:text-[1rem] text-justify md:text-[.9rem] text-[1rem] text-[#7A7A7A]">
          Rawalpindi Development Authority (RDA) was established in May 1989
          under the Punjab Development of Cities Act, 1976 as an autonomous body
          of the Government of Punjab, replacing the Rawalpindi Improvement
          Trust (RIT). The Rawalpindi Development Authority formally began
          functioning in March 1992.
        </span>
        {/* <NavLink
          to={"/about-rda"}
          className="flex text-[#00643b] font-semibold xl:text-[1.2rem] lg:text-[1rem] md:text-[.9rem] text-[1rem] items-center gap-2 cursor-pointer"
        >
          Learn more <span className="xl:text-[2rem] text-[1.5rem]">→</span>
        </NavLink> */}
        <div className="flex justify-start items-center gap-3 mt-4">
          <NavLink
            to={"/about-rda"}
            className=" font-semibold text-[1rem] border-[#00643b] border bg-transparent text-[#00643b] hover:bg-[#00643B]  hover:text-white px-3 py-2 rounded-lg"
          >
            About Us
          </NavLink>
          <NavLink
            to={"/management"}
            className=" font-semibold text-[1rem] border-[#00643b] border bg-[#00643b] text-white hover:text-[#00643B]  hover:bg-transparent px-3 py-2 rounded-lg"
          >
            Management
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default AboutRDA;
